import { Component, inject } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  #themeService: ThemeService = inject(ThemeService);
  isDarkMode: Observable<boolean> = this.#themeService.isDarkMode();

  toggleTheme(): void {
    this.#themeService.switchDarkMode();
  }
}
